import React from 'react'
import classNames from 'classnames'
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlusCircle } from '@fortawesome/pro-regular-svg-icons/faPlusCircle'
import { faHistory } from '@fortawesome/pro-regular-svg-icons/faHistory'
import { GET_LIST, useClient } from '@peracto/client'
import { HydraTable, Heading, SelectFilter, TextFilter } from '@peracto/peracto-ui'

import { RULE_TYPES, RULE_TYPE_OPTIONS } from './ruleTypes'

const ACTIVE_OPTIONS = [
    { label: 'Active', value: 'true' },
    { label: 'Switched off', value: 'false' },
]

const columns = [
    {
        Header: 'Brand',
        accessor: 'brandName',
        sortType: 'basic',
        Cell: ({ row, cell }) => <Link to={row.original['@id']}>{cell.value}</Link>,
        Filter: props => <TextFilter label="Brand" {...props} />,
        selectable: false,
    },
    {
        Header: 'Supplier account',
        accessor: 'supplierAccountCode',
        sortType: 'basic',
        Cell: ({ cell: { value } }) => value || 'None (own brand)',
        Filter: props => <TextFilter label="Supplier account" {...props} />,
        selectable: false,
    },
    {
        Header: 'TecDoc brand number',
        accessor: 'tecDocSupplierId',
        sortType: 'basic',
        Filter: props => <TextFilter label="TecDoc brand number" {...props} />,
        selectable: false,
    },
    {
        Header: 'Rule',
        accessor: 'ruleType',
        sortType: 'basic',
        Cell: ({ row, cell: { value } }) =>
            row.original.ruleValue ? `${RULE_TYPES[value]}: ${row.original.ruleValue}` : RULE_TYPES[value],
        Filter: props => <SelectFilter label="Rule" options={RULE_TYPE_OPTIONS} {...props} />,
        selectable: false,
    },
    {
        Header: 'Status',
        accessor: 'active',
        disableSortBy: true,
        Cell: ({ cell: { value } }) => (
            <span className={classNames('badge', 'badge-pill', value ? 'badge-success' : 'badge-secondary')}>
                {value ? 'Active' : 'Switched off'}
            </span>
        ),
        Filter: props => <SelectFilter label="Status" options={ACTIVE_OPTIONS} {...props} />,
        selectable: false,
    },
]

const RuleList = () => {
    const { client } = useClient()
    const onFetchData = options => client(GET_LIST, 'tecdoc-brand-rules', options)

    return (
        <>
            <Helmet>
                <title>TecDoc Brand Rules | Peracto</title>
            </Helmet>
            <Heading name="TecDoc Brand Rules">
                <div className="d-flex align-items-center ml-2">
                    <Link className="btn btn-link mr-2" to="/tecdoc-rule-changes">
                        <FontAwesomeIcon icon={faHistory} className="mr-2" />
                        Change History
                    </Link>
                    <Link className="btn btn-primary" to="/tecdoc-brand-rules/add" data-testid="add-rule">
                        <FontAwesomeIcon icon={faPlusCircle} className="mr-2" />
                        Add Rule
                    </Link>
                </div>
            </Heading>
            <p className="text-muted">
                How each Somora supplier account's part numbers are matched to a TecDoc brand. An account with
                several TecDoc brands has one rule per brand.
            </p>
            <div className="row">
                <div className="col">
                    <div className="card card--transparent">
                        <div className="card-body">
                            <HydraTable columns={columns} onFetchData={onFetchData} />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default RuleList
